<div class="live">

  <div class="live-item">
    <ul>
      <li>
        <a (click)="showGallery(0)">
          <img
            src="/assets/IMG_1434b_small.jpg"/>
        </a></li>
      <li>
        <a (click)="showGallery(1)">
          <img
            src="/assets/nostromo_small.jpg"/>
        </a></li>
      <li>
        <a (click)="showGallery(2)">
          <img
            src="/assets/tim_small.jpg"/>
        </a></li>
      <li>
        <a (click)="showGallery(3)">
          <img
            src="/assets/kamenz_small.jpg"/>
        </a></li>
      <li>
        <a (click)="showGallery(4)">
          <img
            src="/assets/andy_small.jpg"/>
        </a></li>
      <li>
        <a (click)="showGallery(5)">
          <img
            src="/assets/akustik_small.jpg"/>
        </a>
      </li>
    </ul>
  </div>

  <div class="live-item">
  <span (click)="navigation.home()" style="cursor: pointer;">
        <mat-icon class="back-icon">arrow_back_ios</mat-icon>
        ZURÜCK
      </span>
  </div>
</div>
